<template>
  <scroll-view class="upgrade-index" :scroll="true">
    <div class="upgrade-flex-text">请选择你开通的套餐</div>
    <van-radio-group v-model="radio">
      <div v-for="(item,index) in list" :key="index">
      <van-radio :name="index">
        {{item.name}}
      </van-radio>
      <div class="van-radio-text">
        <div>
          <div>空间容量</div>
          <div>{{item.pic_space}}M</div>
        </div>
        <div>
          <div>大约张数</div>
          <div>{{item.pic_num}}张</div>
        </div>
        <div>
          <div>支付金额</div>
          <div><span style="color: #ff0000;"><span>¥</span>{{item.amount}}</span></div>
        </div>
      </div>
      </div>
    </van-radio-group>
    <div class="upgrade-flex-button" @click="goBack()">去支付</div>
  </scroll-view>
</template>

<script>
  import {
    RadioGroup,
    Radio
  } from 'vant';
  import {
    Albumlevelgetlist,
    doneOrder,
    Albumpaypay
  } from '@/request/api.js'
  export default {
    components: {
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio
    },
    data() {
      return {
        radio: '0',
        list:[]
      }
    },
    created() {
      typeof WeixinJSBridge != 'undefined' && WeixinJSBridge.call('hideOptionMenu');
      this.Albumlevelgetlist_load();
    },
    methods: {
      async Albumlevelgetlist_load(){
        let res = await Albumlevelgetlist('');
        console.log(res.data)
        this.list = res.data;
      },
      goBack() {
        let _self = this;
        let param = {
          level_id:this.list[parseInt(this.radio)].level_id
        }
        this.$api.Message('提示', '是否支付'+ this.list[parseInt(this.radio)].name +'所需要的'+ this.list[parseInt(this.radio)].amount +'金额?').then((res) => {
        	if(res){
            doneOrder(param).then(data=>{
              let param = {
                order_id: data.data.order_id,
                payment_type:'wx',
                param_type:'',
				openid:_self.$store.state.openid
              }
              _self.$api.pay(Albumpaypay,param)
            })
          }
        })
        //history.go(-1);
      }
    }
  }
</script>

<style lang="less">
  .upgrade-index {
    font-size: 1.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F4F4F4;

    .van-radio {
      width: 90%;
      background-color: #FFFFFF;
      padding: 1rem 2%;
      margin-left: 3%;
      box-shadow: 0px 0px 10px #D5D6D8;
    }

    .van-radio-text {
      width: 90%;
      background-color: #FFFFFF;
      margin: 5% 3%;
      margin-top: 0;
      display: flex;
      flex-direction: column;
      color: #999;
      margin-bottom: 1rem;
      padding: 2%;
    }
    .van-radio-text>div{
      width: 96%;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      background-color: rgba(0,0,0,0.05);
      border-bottom: 1px solid #fff;
      padding: 2%;
    }

    .upgrade-flex-text {
      width: 90%;
      margin-bottom: 0.2rem;
      padding: 0.5rem 2%;
      margin-left: 3%;
      color: #999;
      margin-top: 3rem;
    }

    .upgrade-flex-button {
      width: 90%;
      background-color: #2590c8;
      color: #FFFFFF;
      padding: 1rem 2%;
      border-radius: 0.5rem;
      text-align: center;
      margin: 3rem 3%;
    }
  }
</style>
